<template>
  <div
    class="rounded-lg pa-4 mb-1"
    style="cursor: pointer"
    :class="{ 'grey lighten-4 grey--text text--darken-2': !selected, 'primary white--text elevation-10': selected, 'error-card': !valid }"
  >
    <v-row
      no-gutters
      class="text-body-1 flex-nowrap"
      style="min-width: 0"
    >
      <v-col class="text-truncate pr-2">
        <div
          v-if="!event.title"
          class="font-weight-medium"
        >
          {{ $t('event.label.title') }} #{{ index + 1 }}
        </div>
        <div
          v-else
          class="font-weight-medium text-truncate"
        >
          {{ event.title }}
        </div>
      </v-col>
      <v-col
        cols="auto"
        class="text-caption"
      >
        <div v-if="weekDay">
          <span class="grey--text text--lighten-1">
            {{ $dayjs(event.start_at).format('ddd, L') }}
          </span>
          {{ $dayjs(event.start_at).format(getDateTimeFormatForUser('HH:mm')) }}
        </div>
        <div v-else>
          {{ $dayjs(event.start_at).format(getDateTimeFormatForUser('ddd, L - HH:mm')) }}
        </div>
      </v-col>
    </v-row>
    <div
      v-if="week && weekDay"
      class="text-caption mt-1"
    >
      {{ $t('training_programs.dialog.event_list.week') }} {{ week }} &middot; {{ $t('training_programs.dialog.event_list.day') }} {{ weekDay }}
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { getDateTimeFormatForUser } from '@/utils/helpers'

export default {
  name: 'TrainingProgramEventListCard',
  props: {
    event: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    startInstance: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: String,
      default: undefined
    }
  },
  computed: {
    valid() {
      return !(!this.event.title || !this.event.start_time || !this.event.end_time)
    },
    day() {
      if (!this.startDate || this.startInstance) return undefined

      return dayjs(this.event.date).diff(dayjs(this.startDate), 'day')
    },
    week() {
      if (this.day === undefined) return undefined

      return Math.floor(this.day / 7) + 1
    },
    weekDay() {
      if (this.day === undefined || !this.week) return undefined

      return (this.day - (Math.floor(this.day / 7) * 7)) + 1
    }
  },
  methods: { getDateTimeFormatForUser }
}
</script>

<style>
.error-card {
  outline: 1px solid var(--v-error-base) !important;
}
</style>
